import * as i0 from '@angular/core';
import { EventEmitter, Injectable, Component, Input, ViewChild, Inject, NgModule } from '@angular/core';
import * as i1$1 from '@angular/material/dialog';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import * as i5 from 'seguradoras';
import { Integracao, SeguradorasModule, ConfiguracoesModule } from 'seguradoras';
import * as i2$1 from '@angular/router';
import * as i1 from '@angular/common/http';
import * as i1$2 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as i2 from '@angular/platform-browser';
import * as i5$1 from '@angular/material/snack-bar';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import * as i6 from '@angular/common';
import { CommonModule } from '@angular/common';
import { trigger, transition, style, animate } from '@angular/animations';
import * as i4 from '@angular/material/menu';
import { MatMenuModule } from '@angular/material/menu';
import * as i8 from '@angular/material/tooltip';
import { MatTooltipModule } from '@angular/material/tooltip';
import * as i9 from '@angular/material/button';
import { MatButtonModule } from '@angular/material/button';
import * as i10 from 'formulario-vida';
import { LibFormularioVidaModule } from 'formulario-vida';
import * as i11 from 'formulario-auto';
import { LibFormularioAutoModule } from 'formulario-auto';
import * as i12 from 'coberturas-auto';
import { LibCoberturasAutoModule } from 'coberturas-auto';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { MatTableModule } from '@angular/material/table';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatSortModule } from '@angular/material/sort';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

class Erros {
    static formulario = [
        //segurado
        "SEGURADO_CEP",
        "SEGURADO_CPFCNPJ",
        "SEGURADO_DATANASC",
        "SEGURADO_NOME",
        "SEGURADO_SEXO",
        "SEGURADO_EMAIL",
        "SEGURADO_PROFISSAO",
        "SEGURADO_RENDAMENSAL",
        "SEGURADO_TIPOPESSOA",
        "SEGURADO_ESTADOCIVIL",
        "SEGURADO_PESO",
        "SEGURADO_ALTURA",
        //automovel
        "AUTOMOVEIS_FIPE",
        "AUTOMOVEIS_TIPO",
        "AUTOMOVEIS_TPUSO",
        "AUTOMOVEIS_PLACA",
        "AUTOMOVEIS_ZEROKM",
        "AUTOMOVEIS_CHASSI",
        "AUTOMOVEIS_DESCRICAO",
        "AUTOMOVEIS_PCTAJUSTE",
        "AUTOMOVEIS_ANOMODELO",
        "AUTOMOVEIS_CONDUTORES",
        "AUTOMOVEIS_CEPPERNOITE",
        "AUTOMOVEIS_CONDUTORES_RELACCOMSEGURADO",
        "AUTOMOVEIS_DATAHORASAIDALOJA",
        "AUTOMOVEIS_COMBUSTIVEL",
        "AUTOMOVEIS_GASINSTALVALOR",
        "AUTOMOVEIS_CONDUTORES_CPFCNPJ",
        "AUTOMOVEIS_TPCARROCERIA",
        "AUTOMOVEIS_TIPOCARGA",
        "AUTOMOVEIS_EXCLUIRREGIAO",
        "AUTOMOVEIS_VALORCARROCERIA",
        "AUTOMOVEIS_CDANTIFURTO",
        "AUTOMOVEIS_CONDUTORES_TPRESIDENCIA",
        "AUTOMOVEIS_FABRICANTE",
        "AUTOMOVEIS_TIPOISENCAO",
        //coberturas
        "CALCULOS_ISDANOSMATERIAIS",
        "CALCULOS_ISDANOSCORPORAIS",
        "CALCULOS_ISDANOSMORAIS",
        "CALCULOS_ISAPPINVALIDEZ",
        "CALCULOS_ISAPPMORTE",
        "CALCULOS_VIDROS",
        "CALCULOS_CARRORESERVA",
        "CALCULOS_HIGIENIZACAO",
        "CALCULOS_MARTELINHOOURO",
        "CALCULOS_TIPOFRANQUIA",
        "CALCULOS_BLINDAGEM",
        "CALCULO_ISDANOSMORAIS",
        "CALCULOS_ISBLINDAGEMVALOR",
        //coberturas
        "CONFIGURACOES",
        "CONFIGURACOES_FUNERAL",
        "CONFIGURACOES_RESPONSABILIDADECIVIL",
        "CONFIGURACOES_ISDANOSINCENDIORAIOEXPLOSAO",
        "CONFIGURACOES_IMOVELOBJETOSEGURADO",
        "CONFIGURACOES_IMOVELCONSTRUCAO",
        "CONFIGURACOES_IMOVELCEP",
        "CONFIGURACOES_ISDANOSIMPACTOVEICULO",
        "CONFIGURACOES_ISDANOSROUBO",
        "CONFIGURACOES_ISDANOSVENDAVAL",
        "CONFIGURACOES_ISDANOSALUGUEL",
        "CONFIGURACOES_ISDANOSVAZAMENTOTANQUESTUBULACOES",
        "CONFIGURACOES_IMOVELATIVIDADEPROFISSIONALLOCAL",
        "CONFIGURACOES_VIDROS",
        "CONFIGURACOES_ISAPPMORTEACIDENTAL",
        "CONFIGURACOES_ISDANOSELETRICOS",
        "CONFIGURACOES_ISDANOSDESMORONAMENTO",
        "CONFIGURACOES_ISDANOSALAGAMENTO",
        "CONFIGURACOES_ISVALORSINDICO",
        "CONFIGURACOES_ISDANOSPORTOES",
        "CONFIGURACOES_IMOVELUSO",
        "CONFIGURACOES_IMOVELCIDADE",
        "CONFIGURACOES_IMOVELATIVIDADE",
        "CONFIGURACOES_TUMULTOGREVELOCKOUT",
        "CONFIGURACOES_RC_EMPREGADOR",
        "CONFIGURACOES_DANOS_MORAIS",
        "CONFIGURACOES_RC_GUARDA_VEICULO",
        "CONFIGURACOES_ISVALORCONDOMINIO",
        "CONFIGURACOES_ISDESPESASMEDICASHOSPITALARES",
        "CONFIGURACOES_IMOVELALARME",
        "CONFIGURACOES_ISAPPINVALIDEZ",
        "CONFIGURACOES_ISAPPMORTE",
        "CONFIGURACOES_ISDOECASGRAVESGRUPO",
        "CONFIGURACOES_DIT",
        "CONFIGURACOES_ISDANOSDESPESASFIXAS",
        "CONFIGURACOES_ISEMPREGADOR",
        "CONFIGURACOES_RESPONSABILIDADECIVILOPERACOES",
        //rains form
        "TPCOBERTURA",
        "NUMERORENOVACAO",
        "BONUSANTERIOR",
        "VIGENCIAINI",
        "TPCOBERTURA",
        "SEGURADORAANTERIORID",
        "SINISTROSANTERIOR",
        "RENOVACAO",
    ];
    static reenviar = [
        "CALCULO_INSTABILIDADE",
        "CALCULO_RECAPTCHA",
        "CALCULO_ERRO",
    ];
    static seguradoras = [
        "CALCULOS_LOGIN",
        "CALCULOS_SUSEP",
        "CALCULOS_SUCURSAL",
        "CALCULOS_INSPETORIA",
        "CALCULOS_FILIAL",
        "CALCULOS_CODIGOCORRETOR",
        "CALCULOS_PERCCOMISSAO",
        "CALCULOS_PERCDESCONTO",
        "VALIDAR_ACESSO",
        "CALCULOS_BRADESCOCPFCNPJ",
        "CALCULOS_BRADESCOAGENCIAPRODUTOR",
    ];
    static formVida = {
        SEGURADO_CPFCNPJ: false,
        SEGURADO_NOME: false,
        SEGURADO_DATANASC: false,
        SEGURADO_SEXO: false,
        SEGURADO_ESTADOCIVIL: false,
        SEGURADO_ALTURA: false,
        SEGURADO_PESO: false,
        SEGURADO_FUMANTE: false,
        SEGURADO_PROFISSAO: false,
        SEGURADO_RENDA: false,
        SEGURADO_FONE: false,
        SEGURADO_EMAIL: false,
        SEGURADO_CEP: false,
        CONFIGURACOES_ISAPPMORTE: false,
        CONFIGURACOES_ISAPPMORTEACIDENTAL: false,
        CONFIGURACOES_ISAPPINVALIDEZ: false,
        CONFIGURACOES_FUNERAL: false,
        CONFIGURACOES_ISDESPESASMEDICASHOSPITALARES: false,
        CONFIGURACOES_ISINVALIDEZDOENCAS: false,
        CONFIGURACOES_DIT: false,
        CONFIGURACOES_ISVALORDIT: false,
        CONFIGURACOES_ISESPORTE: false,
        CONFIGURACOES_ISDOECASGRAVESGRUPO: false,
        CONFIGURACOES_ISVALORDOENCASGRAVES: false,
        VIGENCIAINI: false
    };
    static formAuto = {
        SEGURADO_CPFCNPJ: false,
        SEGURADO_NOME: false,
        SEGURADO_DATANASC: false,
        SEGURADO_SEXO: false,
        SEGURADO_ESTADOCIVIL: false,
        SEGURADO_FONE: false,
        SEGURADO_EMAIL: false,
        SEGURADO_CEP: false,
        //condutor
        AUTOMOVEIS_CONDUTORES: false,
        AUTOMOVEIS_CONDUTORES_RELACCOMSEGURADO: false,
        AUTOMOVEIS_CONDUTORES_TEMPOHABILITACAO: false,
        AUTOMOVEIS_CONDUTORES_DATAPRIMHABIL: false,
        AUTOMOVEIS_CONDUTORES_CPFCNPJ: false,
        AUTOMOVEIS_CONDUTORES_NOME: false,
        AUTOMOVEIS_CONDUTORES_ESTADOCIVIL: false,
        AUTOMOVEIS_CONDUTORES_SEXO: false,
        AUTOMOVEIS_CONDUTORES_DATANASC: false,
        AUTOMOVEIS_CONDUTORES_PROFISSAO: false,
        AUTOMOVEIS_CONDUTORES_TPRESIDENCIA: false,
        //automovel
        AUTOMOVEIS_ZEROKM: false,
        AUTOMOVEIS_DATAHORASAIDALOJA: false,
        AUTOMOVEIS_PLACA: false,
        AUTOMOVEIS_CHASSI: false,
        AUTOMOVEIS_FIPE: false,
        AUTOMOVEIS_ANOMODELO: false,
        AUTOMOVEIS_ANOFABRICACAO: false,
        AUTOMOVEIS_DESCRICAO: false,
        AUTOMOVEIS_COMBUSTIVEL: false,
        AUTOMOVEIS_VALREFERENCIADO: false,
        AUTOMOVEIS_GASINSTALVALOR: false,
        AUTOMOVEIS_TIPO: false,
        AUTOMOVEIS_PORTAS: false,
        AUTOMOVEIS_PASSAGEIROS: false,
        AUTOMOVEIS_FABRICANTE: false,
        AUTOMOVEIS_TIPOISENCAO: false,
        AUTOMOVEIS_FINANCIADO: false,
        AUTOMOVEIS_ANTIFURTO: false,
        AUTOMOVEIS_PCTAJUSTE: false,
        AUTOMOVEIS_CDANTIFURTO: false,
        AUTOMOVEIS_CEPPERNOITE: false,
        AUTOMOVEIS_CEPCIRCULACAO: false,
        AUTOMOVEIS_KMANUAL: false,
        AUTOMOVEIS_JOVEMCONDUTOR: false,
        AUTOMOVEIS_JOVEMSEXO: false,
        AUTOMOVEIS_JOVEMIDADE: false,
        AUTOMOVEIS_TPUSO: false,
        AUTOMOVEIS_IDA_VOLTA_ESTUDO: false,
        AUTOMOVEIS_IDA_VOLTA_TRABALHO: false,
        AUTOMOVEIS_PCD: false,
        //CAMINHAO
        AUTOMOVEIS_TPCARROCERIA: false,
        AUTOMOVEIS_TIPOCARGA: false,
        AUTOMOVEIS_EXCLUIRREGIAO: false,
        AUTOMOVEIS_VALORCARROCERIA: false,
        AUTOMOVEIS_EIXOS: false,
        SINISTROSANTERIOR: false,
        RENOVACAO: false,
        SEGURADORAANTERIORID: false,
        BONUSANTERIOR: false,
        NUMERORENOVACAO: false,
        CI: false,
        TPCOBERTURA: false,
        VIGENCIAINI: false,
        ANTERIOR_VIGENCIAINI: false,
        VIGENCIAFIM: false,
        ANTERIOR_VIGENCIAFIM: false,
        //coberturas
        CALCULOS_ISDANOSMATERIAIS: false,
        CALCULOS_ISDANOSCORPORAIS: false,
        CALCULOS_ISDANOSMORAIS: false,
        CALCULOS_ISAPPINVALIDEZ: false,
        CALCULOS_ISAPPMORTE: false,
        CALCULOS_VIDROS: false,
        CALCULOS_CARRORESERVA: false,
        CALCULOS_HIGIENIZACAO: false,
        CALCULOS_MARTELINHOOURO: false,
        CALCULOS_TIPOFRANQUIA: false,
        CALCULOS_BLINDAGEM: false,
        CALCULO_ISDANOSMORAIS: false,
        CALCULOS_ISBLINDAGEMVALOR: false,
        CALCULOS_PACOTE: false,
        CALCULOS_VALORNOVO: false,
        CALCULOS_DESPESASEXTRAS: false,
        CALCULOS_PROTECAOPNEURODAS: false,
        CALCULOS_GUINCHOKM: false,
        REPARORAPIDO: false,
        CALCULOS_LATERNAFAROLAUCILIAR: false,
    };
    static segNomes = {
        1: 'Bradesco Seguros',
        2: 'Yelum Seguros',
        3: 'Mapfre Seguros',
        4: 'HDI Seguros',
        5: 'Allianz Seguros',
        6: 'Sompo Seguros',
        7: 'Zurich Seguros',
        8: 'Porto Seguro ',
        9: 'Icatu Seguros',
        10: 'Azul Seguros',
        11: 'Tokio Seguros',
        12: 'Yelum Seguros',
        13: 'Mitsui Seguros',
        14: 'Generali Seguros',
        15: 'Icatu Seguros',
        16: 'Sompo Seguros',
        17: 'SulAmérica Seguros',
        18: 'Alfa Seguros',
        19: 'Sancor Seguros',
        20: 'Suhai Seguros',
        21: 'Tokio Seguros',
        22: 'Aliro Seguros'
    };
    static seguradoraNome(id) {
        try {
            return this.segNomes[id];
        }
        catch (e) {
            return '';
        }
    }
}

class ConstantRecalculo {
    CODIGOS_POSSIVEIS_CORRIGIR = [
        1, 2, 3, 4, 5, 9, 10, 11, 12, 13, 14,
        15, 16, 18, 19, 20, 21, 23, 213, 41,
        60, 32, 104, 24, 22, 25, 26, 27, 29,
        53, 91, 116, 178, 190, 209, 210,
        42, 75, 79, 92, 119, 290, 340, 322
    ];
    static get ramos() {
        return {
            AUTO: 31,
            CARRO: 31,
            MOTOCICLETA: 31,
            CAMINHAO: 31,
            VIDA: 91,
            RESIDENCIAL: 2,
            EMPRESARIAL: 18,
            CONDOMINIO: 16
        };
    }
}
// /#/app/cotacao/carro/resultados/3d93524d-b3bf-421a-b2a6-fe242a0ed5f2

class RecalculoService {
    http;
    dialog;
    constant;
    erroList = [];
    eventCalculo = new EventEmitter();
    eventCarregado = new EventEmitter();
    dialogRef;
    constructor(http, dialog, constant) {
        this.http = http;
        this.dialog = dialog;
        this.constant = constant;
        this.getListError().then(response => this.erroList = response);
    }
    calculosElegiveis(ramo, seguradora, codigoErroPrincipal) {
        let errroSelecionado = this.erroList.find(err => err.id == codigoErroPrincipal);
        if (errroSelecionado)
            errroSelecionado = errroSelecionado.attributes;
        if ([5, 53, 91, 16, 18, 19, 20, 116, 178, 190, 209, 210].includes(parseInt(codigoErroPrincipal))) {
            errroSelecionado = [
                "AUTOMOVEIS_FIPE",
                "AUTOMOVEIS_PLACA",
                "AUTOMOVEIS_ZEROKM",
                "AUTOMOVEIS_CHASSI",
                "AUTOMOVEIS_DESCRICAO",
                "AUTOMOVEIS_ANOMODELO",
                "AUTOMOVEIS_DATAHORASAIDALOJA",
                "AUTOMOVEIS_COMBUSTIVEL",
                "AUTOMOVEIS_ANOFABRICACAO"
            ];
        }
        if ([42, 75, 79, 92, 119, 165, 290, 340].includes(parseInt(codigoErroPrincipal))) {
            errroSelecionado = [
                "SEGURADO_CPFCNPJ",
                "SEGURADO_NOME",
                "SEGURADO_DATANASC",
                "SEGURADO_SEXO",
                "SEGURADO_ESTADOCIVIL",
                "SEGURADO_FONE",
                "SEGURADO_EMAIL",
                "SEGURADO_CEP"
            ];
        }
        let calculosElegiveis = {};
        let errForm = false;
        let errSeg = false;
        let resolveDireto = false;
        for (let item of errroSelecionado) {
            errSeg = Erros.seguradoras.includes(item);
            errForm = Erros.formulario.includes(item);
            resolveDireto = Erros.reenviar.includes(item);
            if (errSeg || errForm || resolveDireto)
                break;
        }
        let tipo = errForm ? "FORM" : errSeg ? "SEGURADORA" : "";
        calculosElegiveis.habilitar = true;
        calculosElegiveis.seg = seguradora;
        calculosElegiveis.abreSeguradora = errSeg;
        calculosElegiveis.tipoCorrecao = tipo;
        calculosElegiveis.reenviar = resolveDireto;
        calculosElegiveis.ramo = ramo;
        calculosElegiveis.attribute = errroSelecionado;
        return calculosElegiveis;
    }
    habilitaRecalculo(resultado, calculo, versao, permissao = null) {
        let habilitar = false;
        //pego objeto com os calculos
        try {
            if (calculo && calculo?.informacoesExecucao) {
                let informacoesExecucao = calculo.informacoesExecucao;
                let codigoErroPrincipal = parseInt(informacoesExecucao.codigoErroPrincipal);
                if (!this.constant.CODIGOS_POSSIVEIS_CORRIGIR.includes(codigoErroPrincipal)) {
                    resultado.recalculo = false;
                    return;
                }
                const errroSelecionado = this.erroList.find(err => err.id == codigoErroPrincipal);
                let errSeg = false, errForm = false, resolveDireto = false;
                if ([273].includes(codigoErroPrincipal)) {
                    errroSelecionado.attributes = [
                        "SEGURADO_PESO",
                        "SEGURADO_ALTURA"
                    ];
                }
                for (let item of errroSelecionado?.attributes) {
                    errSeg = Erros.seguradoras.includes(item);
                    errForm = Erros.formulario.includes(item);
                    resolveDireto = Erros.reenviar.includes(item);
                }
                if (errSeg || errForm || resolveDireto)
                    habilitar = true;
                if (permissao?.grupo == 'Calculista' && permissao?.cgfModo == 1 && errSeg)
                    habilitar = false;
                resultado.recalculo = habilitar;
                resultado.idNegocio = versao.idIntegracao;
                resultado.idCalculo = calculo.idCalculo;
                resultado.codigoErroPrincipal = calculo.informacoesExecucao.codigoErroPrincipal;
                resultado.adminBotsNaoPodeAbrir = resolveDireto || errSeg;
            }
            else {
                resultado.recalculo = false;
            }
        }
        catch (err) {
            resultado.recalculo = false;
        }
    }
    getListError() {
        // return this.http.get('http://p-docs-lb-289535233.us-east-1.elb.amazonaws.com:3000/getErrorList').toPromise()
        return this.http.get('https://p-docs-prod.s3.us-east-1.amazonaws.com/utils/ErrorList.json').toPromise()
            .then(response => this.erroList = response);
    }
    emitirEventoCalculo(draft) {
        this.eventCalculo.emit(draft);
    }
    emitirCarregamento(value) {
        this.eventCarregado.emit(value);
    }
    abreModal(component, resultado, currentVersion, api, cotacaoService, aplicacao = 1) {
        debugger;
        const arrSegs = [];
        currentVersion.calculos.map(item => {
            arrSegs.push(item.seguradora);
        });
        const config = api.wakUser.confsSeguradora.find(seg => seg.seguradora == resultado.seguradora);
        return new Promise(async (resolve) => {
            this.dialogRef = this.dialog.open(component, {
                data: {
                    api: api,
                    idNegocio: resultado.idNegocio ? resultado.idNegocio : currentVersion.id,
                    idCalculo: resultado.idCalculo,
                    seguradora: resultado.seguradora,
                    versao: currentVersion.versao,
                    proposta: currentVersion,
                    arrSegs,
                    erros: resultado.msErros,
                    ramo: currentVersion.ramo,
                    codigoErroPrincipal: resultado.codigoErroPrincipal,
                    cotacaoService: cotacaoService,
                    aplicacao: aplicacao,
                    config: config,
                    recalculo: true
                },
                panelClass: 'modalRecalculo',
                width: '649px',
                maxHeight: '90vh'
            });
            this.dialogRef.afterClosed()
                .subscribe(response => {
                this.dialogRef.componentInstance.clearInjetado();
                if (typeof response != 'object') {
                    resolve(false);
                }
                else {
                    cotacaoService.enviaRecalculo({ newVersion: response.novaVersao, versao: currentVersion.versao, idIntegracao: resultado.idNegocio ? resultado.idNegocio : currentVersion.id });
                    resolve(resultado.seguradora);
                }
            });
        });
    }
    desabilitaBotaoRecalcular(wakUser) {
        try {
            const grupo = wakUser.grupo;
            return { desabilita: grupo === 'Admin-Bots' || grupo === 'Admin', mensagem: 'Recurso não disponível para seu grupo de usuário.' };
        }
        catch (error) {
            return { desabilita: false, mensagem: '' };
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: RecalculoService, deps: [{ token: i1.HttpClient }, { token: i1$1.MatDialog }, { token: ConstantRecalculo }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: RecalculoService, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: RecalculoService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: i1.HttpClient }, { type: i1$1.MatDialog }, { type: ConstantRecalculo }] });

class RegisterIconsService {
    matIconRegistry;
    domSanitizer;
    constructor(matIconRegistry, domSanitizer) {
        this.matIconRegistry = matIconRegistry;
        this.domSanitizer = domSanitizer;
    }
    registerIcons(icons) {
        this.loadIcons(icons, 'assets/images/icons-svg');
    }
    loadIcons(iconKeys, iconUrl) {
        iconKeys.forEach(key => {
            this.matIconRegistry.addSvgIcon(key, this.domSanitizer.bypassSecurityTrustResourceUrl(`${iconUrl}/${key}.svg`));
        });
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: RegisterIconsService, deps: [{ token: i1$2.MatIconRegistry }, { token: i2.DomSanitizer }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: RegisterIconsService, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: RegisterIconsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: i1$2.MatIconRegistry }, { type: i2.DomSanitizer }] });

// import { LibFormularioVidaComponent } from 'projects/formulario-vida/src/public-api';
// import { LibFormularioAutoComponent } from 'projects/formulario-auto/src/public-api';
// import { CoberturasAutoComponent } from 'projects/coberturas-auto/src/public-api';
// import { ModalSeguradoraComponent } from 'projects/seguradoras/src/public-api';
class RecalculoModalComponent {
    dialogRef;
    registerIcon;
    service;
    loadSave = false;
    seguradoraId = null;
    formulario;
    modalSeguradora;
    constantErr = Erros;
    dataSeguradora;
    libSeguradora;
    habilitaComponent;
    seguradorasStatus;
    coberturas;
    draft;
    campos = {};
    json;
    msErros = [];
    nomeSeguradora;
    aplicacao;
    dadosSalvo = false;
    coberturasUser;
    currentVersion;
    _ramos = ConstantRecalculo.ramos;
    tokenPdocs;
    injetadoObj;
    recalcularControler = {
        desabilita: false,
        mensagem: ''
    };
    set seg(value) {
        this.seguradoraId = value;
    }
    set libSeg(value) {
        this.libSeguradora = value;
    }
    set habilitar(value) {
        this.habilitaComponent = value;
    }
    set dataForm(value) {
        debugger;
        if (value) {
            this.dataSeguradora = value;
        }
    }
    set erros(value) {
        this.msErros = value;
    }
    set config(value) {
        this.campos = value;
    }
    set injetado(value) {
        this.injetadoObj = value;
    }
    set seguradorasInfo(value) {
        this.seguradorasStatus = value;
    }
    set aplicacaoId(value) {
        this.aplicacao = value;
    }
    set contentFormulario(contentFormulario) {
        this.formulario = contentFormulario;
        if (this.formulario)
            this.initializeFormulario();
    }
    set contentCoberturas(contentCoberturas) {
        this.coberturas = contentCoberturas;
        if (this.coberturas)
            this.inicializeCobAuto();
    }
    set contentModalSeguradora2(contentModalSeguradora) {
        this.modalSeguradora = contentModalSeguradora;
        if (this.modalSeguradora) {
            this.modalSeguradora;
            this.setaConfigSeguradoraComoAtiva();
            setTimeout(() => {
                this.service.emitirCarregamento(false);
            }, 1000);
        }
    }
    constructor(dialogRef, registerIcon, service) {
        this.dialogRef = dialogRef;
        this.registerIcon = registerIcon;
        this.service = service;
        const icons = ['calculator.svg'];
        registerIcon.registerIcons(icons);
    }
    ngOnInit() {
        this.recalcularControler = this.service.desabilitaBotaoRecalcular(this.injetadoObj.wakUser);
        this.nomeSeguradora = this.constantErr.seguradoraNome(this.seguradoraId);
    }
    /*async initializeFormulario() {
      this.formulario.api.setModo(this.injetadoObj.aplicacao, this.injetadoObj.api.ENV.production ? 'PROD' : 'DEV', this.injetadoObj.token);
      let ccvv = await this.injetadoObj.api.getNegocio(this.injetadoObj.idNegocio);
      this.draft = await this.injetadoObj.cotacaoService.createDraft(ccvv, this.injetadoObj.ramo, this.injetadoObj.api);
      this.formulario.initialize(this.draft).then(() => this.formulario.setRecalculo(this.campos));
      this.service.emitirCarregamento(this.verificaPrecisaPararLoader(this.injetadoObj.ramo));
    }*/
    async initializeFormulario() {
        let ccvv = await this.injetadoObj.api.getNegocio(this.injetadoObj.idNegocio);
        this.draft = await this.injetadoObj.cotacaoService.createDraft(ccvv, this.injetadoObj.ramo, this.injetadoObj.api);
        this.formulario.initialize(this.draft).then(() => {
            this.formulario.setRecalculo(this.campos);
        });
        this.service.emitirCarregamento(this.verificaPrecisaPararLoader(this.injetadoObj.ramo));
    }
    sleep(tempo = 1000) {
        return new Promise(resolve => setTimeout(resolve, tempo));
    }
    async inicializeCobAuto() {
        const versoes = await this.injetadoObj.api.getVersoes(this.injetadoObj.idNegocio);
        if (Array.isArray(versoes))
            this.currentVersion = versoes[this.injetadoObj.versao - 1];
        this.coberturas.initialize(this.coberturasUser, this.currentVersion, this.draft, true);
        await this.sleep(500);
        this.service.emitirCarregamento(false);
    }
    setaConfigSeguradoraComoAtiva() {
        try {
            if (!this.modalSeguradora.formSubmitseguradoras.controls.ativo.value) {
                this.modalSeguradora.segAtiva = true;
                this.modalSeguradora.seguradoraAtivo();
            }
        }
        catch (error) {
            return false;
        }
    }
    async calcular(type) {
        if (!this.recalcularControler.desabilita) {
            //salva as configurações de seguradora, caso o erro do de validação de login/senha e verifica também se já não foi salvo
            if (this.injetadoObj.tipoCorrecao == "SEGURADORA" && !this.dadosSalvo)
                this.salvar();
            var selectedCob;
            var sendDraft;
            if (this.habilitaComponent?.seguradoras) {
                this.service.emitirEventoCalculo({ newVersion: false });
            }
            else if (this.habilitaComponent?.ramo) {
                if (this.coberturas)
                    selectedCob = this.coberturas.getCoberturas();
                await this.formulario.recalcular();
                sendDraft = this.injetadoObj.cotacaoService.getCalcObject(this.draft, this.seguradorasStatus, selectedCob);
                this.service.emitirEventoCalculo({ newVersion: true, sendDraft, all: type == 2 });
            }
        }
    }
    async salvar() {
        try {
            this.loadSave = true;
            this.modalSeguradora;
            await this.modalSeguradora?.salvar();
            this.dadosSalvo = true;
            this.loadSave = false;
        }
        catch (e) {
            this.loadSave = false;
        }
    }
    verificaPrecisaPararLoader(ramo) {
        // Se for ramo auto, o coberturas-auto vai parar o loader.
        return ramo === this._ramos.AUTO;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: RecalculoModalComponent, deps: [{ token: i1$1.MatDialogRef }, { token: RegisterIconsService }, { token: RecalculoService }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: RecalculoModalComponent, selector: "app-recalculo-modal", inputs: { seg: "seg", libSeg: "libSeg", habilitar: "habilitar", dataForm: "dataForm", erros: "erros", config: "config", injetado: "injetado", seguradorasInfo: "seguradorasInfo", aplicacaoId: "aplicacaoId" }, viewQueries: [{ propertyName: "contentFormulario", first: true, predicate: ["formulario"], descendants: true }, { propertyName: "contentCoberturas", first: true, predicate: ["coberturasAuto"], descendants: true }, { propertyName: "contentModalSeguradora2", first: true, predicate: ["modalSeguradora"], descendants: true }], ngImport: i0, template: "<div class=\"modal-container recalculo\">\r\n\r\n  <header class=\"header\">\r\n      <div>\r\n          <section *ngIf=\"seguradoraId\">\r\n              <img class=\"logo-seg\" src=\"assets/images/logos-seguradoras/seguradora{{seguradoraId}}.png\" alt=\"Logo seguradora\">\r\n          </section>\r\n          <section class=\"info\">\r\n              <h1>Recalcular Cota\u00E7\u00E3o</h1>\r\n              <span> {{nomeSeguradora}}</span>\r\n          </section>\r\n      </div>\r\n      <section class=\"button-close-modal\" id=\"botao-recalculo\">\r\n        <button mat-icon-button [mat-dialog-close]=\"true\" class=\"button-close\">\r\n            <mat-icon>close</mat-icon>\r\n        </button>\r\n      </section>\r\n  </header>\r\n\r\n  <main class=\"informacao-erro\">\r\n    <div>\r\n        <mat-icon svgIcon=\"alert-circle-outline\"></mat-icon>\r\n        <span>Foram identificados os seguintes erros durante a tentativa de gerar o c\u00E1lculo:</span>\r\n    </div>\r\n    <ul>\r\n        <li *ngFor=\"let erro of msErros\">\r\n            {{erro}}\r\n        </li>\r\n    </ul>\r\n  </main>\r\n    <span class=\"sub-title\">\r\n       Fa\u00E7a as altera\u00E7\u00F5es necess\u00E1rias para recalcular nesta seguradora.\r\n    </span>\r\n\r\n    <div class=\"section-seg\" *ngIf=\"habilitaComponent?.seguradoras && dataSeguradora\">\r\n        <lib-configuracoes #modalSeguradora id=\"recalculo-seguradora-modal\"></lib-configuracoes>\r\n    </div>\r\n\r\n    <div class=\"section-seg\" *ngIf=\"this.habilitaComponent.ramo == this._ramos.VIDA\">\r\n          <lib-formulario-vida\r\n          #formulario\r\n          *ngIf=\"campos\"\r\n          id=\"form-vida-recalculo\">\r\n          </lib-formulario-vida>\r\n    </div>\r\n\r\n    <div class=\"section-seg\" *ngIf=\"this.habilitaComponent.ramo == this._ramos.AUTO\">\r\n      <lib-formulario-auto\r\n        #formulario\r\n        *ngIf=\"campos\"\r\n        id=\"form-vida-recalculo\">\r\n      </lib-formulario-auto>\r\n      <lib-coberturas-auto\r\n        #coberturasAuto\r\n        *ngIf=\"campos\"\r\n        [listaCampo]=\"campos\"\r\n        id=\"form-vida-recalculo\">\r\n      </lib-coberturas-auto>\r\n    </div>\r\n\r\n</div>\r\n\r\n<div class=\"modal-bottom footer-recalc\">\r\n  <section id=\"footer-recalculo\">\r\n    <button mat-button class=\"recalcular font-18\"\r\n            *ngIf=\"habilitaComponent?.seguradoras\"\r\n            [disabled]=\"recalcularControler.desabilita\"\r\n            [ngClass]=\"recalcularControler.desabilita ? 'desabilitado' : ''\"\r\n            [matTooltip]=\"recalcularControler.desabilita ? recalcularControler.mensagem : 'Recalcular apenas esta seguradora na mesma vers\u00E3o'\"\r\n            [matTooltipPosition]=\"'above'\"\r\n            (click)=\"calcular(1)\">Recalcular</button>\r\n\r\n            <!-- [disabled]=\"recalcularControler.desabilita\" -->\r\n     <button mat-button class=\"recalcular font-18\"\r\n            *ngIf=\"!habilitaComponent?.seguradoras\"\r\n\r\n            [ngClass]=\"recalcularControler.desabilita ? 'desabilitado' : ''\"\r\n            [matMenuTriggerFor]=\"menu\">Recalcular</button>\r\n\r\n     <mat-menu #menu=\"matMenu\" yPosition=\"above\">\r\n       <p class=\"text-recalc\">Nova vers\u00E3o</p>\r\n       <button mat-menu-item class=\"menuItem-recalculo\" (click)=\"calcular(2)\" >Todas seguradoras</button>\r\n       <button mat-menu-item class=\"menuItem-recalculo\" (click)=\"calcular(1)\" >Apenas esta seguradora</button>\r\n     </mat-menu>\r\n  </section>\r\n</div>\r\n", styles: ["@import\"https://fonts.googleapis.com/css?family=Montserrat:500,600,600i,700\";@import\"https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;1,100;1,200;1,300;1,400;1,500;1,600;1,700&display=swap\";.recalculo{font-family:IBM Plex Sans!important}.modal-container{display:flex;flex-direction:column;width:auto;padding:24px}::ng-deep #modalseguradora>button{display:flex}::ng-deep #recalculo-seguradora-modal #modalseguradora{overflow:hidden!important;padding:0}.header{display:flex;align-items:center;justify-content:space-between}.header div{display:flex;align-items:center}.header .logo-seg{width:60px}.header .info{padding-left:16px;align-items:center;padding-top:14px}.header .info h1{margin:0;font-size:18px;font-weight:500;line-height:0px;text-align:left;color:#454750}.header .info span{line-height:49px;font-size:16px;font-weight:500;text-align:left;color:#7e7f86}.header .button-close-modal{width:10px;position:relative;right:27px;top:-14px}.informacao-erro{margin:15px 0;border:1px solid #e5e6e7;border-radius:5px;padding:0}.informacao-erro div{display:flex;align-content:center;align-items:center}.informacao-erro div span{font-size:12px;font-weight:400;color:#60616a}.informacao-erro div mat-icon{margin:10px 12px;color:#d0b249;width:17px}.informacao-erro ul li{font-size:12px;font-weight:400;color:#60616a;list-style:disc!important;margin-left:40px!important;padding-bottom:15px}.sub-title{font-size:14px;font-weight:500;color:#9c9da2;margin-bottom:4px}.footer-recalc{display:flex;width:100%;justify-content:flex-end;border-top:1px #d0d0d0 solid;padding:15px 5%;height:54px}.footer-recalc section{display:flex;align-content:center;align-items:center}.modal-bottom section .recalcular{font-family:IBM Plex Sans!important;font-size:15px;letter-spacing:normal;text-transform:uppercase;float:right;text-decoration:none;font-style:normal;font-weight:500;line-height:normal;letter-spacing:.24px}.modal-bottom section .recalcular:not(.desabilitado){cursor:pointer;color:var(--primary);font-family:IBM Plex Sans!important;font-size:15px;font-style:normal;font-weight:500;line-height:normal;letter-spacing:.24px}.modal-bottom section .nova-versao{font-size:15px;font-family:IBM Plex Sans!important;letter-spacing:normal;text-transform:uppercase;float:right;text-decoration:none;margin-right:21px;display:flex;gap:4px;font-style:normal;font-weight:500;line-height:normal;letter-spacing:.24px}.modal-bottom section .nova-versao:not(.desabilitado){font-size:15px;cursor:pointer;color:#000;font-family:IBM Plex Sans!important;font-style:normal;font-weight:500;line-height:normal;letter-spacing:.24px}.modal-bottom section .desabilitado{font-size:15px;cursor:default;color:#00000061;font-family:IBM Plex Sans!important;font-style:normal;font-weight:500;line-height:normal;letter-spacing:.24px}::ng-deep #form-vida-recalculo .container-form-auto .mat-mdc-form-field{padding:0!important}::ng-deep #form-vida-recalculo .mat-expansion-panel{box-shadow:none;margin:0!important;padding:0!important}::ng-deep #form-vida-recalculo .title-hide,::ng-deep #form-vida-recalculo .desabilitado{display:none}::ng-deep #form-vida-recalculo .mat-expansion-panel-content{margin:0!important;padding:0!important}::ng-deep #form-vida-recalculo .mat-accordion{margin:0!important}::ng-deep #form-vida-recalculo .mat-expansion-panel-body{padding:0 0 7px}::ng-deep #form-vida-recalculo .container-form .mat-accordion{margin:0!important}::ng-deep #form-vida-recalculo .form-step{padding:0!important}::ng-deep #form-vida-recalculo .mat-mdc-card{border:none;box-shadow:none;background:none;padding:0;margin:0}::ng-deep #form-vida-recalculo .container-form{padding:0}::ng-deep #form-vida-recalculo .container-coberturas .card-coberturas .container-title h2{margin:-42px 0 10px!important;padding:7px!important}::ng-deep #form-vida-recalculo .container-coberturas .mat-mdc-form-field{padding:0!important}::ng-deep #recalculo-seguradora-modal #modalseguradora .fields{padding:0!important;margin:0!important}::ng-deep #recalculo-seguradora-modal #modalseguradora{display:contents}::ng-deep #recalculo-seguradora-modal #modalseguradora form{padding:0!important}::ng-deep #recalculo-seguradora-modal #modalseguradora .fields .organizarPadrao .title h3{color:#202124;font-size:15px;margin:0;font-weight:400}::ng-deep #recalculo-seguradora-modal #modalseguradora .mat-mdc-text-field-wrapper .mat-mdc-form-field-infix .mat-mdc-floating-label{letter-spacing:1.8px}::ng-deep #recalculo-seguradora-modal #modalseguradora .fields .organizarPadrao .campoSenha .mat-mdc-form-field-icon-suffix button{margin:0 0 -20px}::ng-deep #recalculo-seguradora-modal #modalseguradora .fields .organizarPadrao .campoSenha .mat-mdc-form-field-icon-suffix button mat-icon{font-size:19px}::ng-deep #recalculo-seguradora-modal #modalseguradora .fields .organizarPadrao .campo .mat-mdc-button .credencial-valida{color:#000000de;margin-top:8px;font-size:13px}::ng-deep #botao-recalculo .mat-mdc-icon-button,::ng-deep #botao-recalculo .mat-mdc-icon-button:hover,::ng-deep #botao-recalculo .mat-mdc-icon-button:active,::ng-deep #botao-recalculo .mat-mdc-icon-button:focus{--mat-mdc-button-persistent-ripple-color:none }::ng-deep .menuItem-recalculo .mdc-list-item__primary-text{color:var(--color-tertiary-first);font-family:IBM Plex Sans;font-size:16px;font-style:normal;font-weight:400;line-height:normal;letter-spacing:.24px}::ng-deep .menuItem-recalculo{color:var(--color-tertiary-first)}::ng-deep .menuItem-recalculo:hover{background:var(--color-tertiary-first)}::ng-deep .text-recalc{color:var(--gray-scale-200, #7E8088);font-family:IBM Plex Sans;font-size:12px;font-style:normal;font-weight:500;line-height:normal;margin:0 17px 4px!important;letter-spacing:.18px}\n"], dependencies: [{ kind: "component", type: i4.MatMenu, selector: "mat-menu", inputs: ["backdropClass", "aria-label", "aria-labelledby", "aria-describedby", "xPosition", "yPosition", "overlapTrigger", "hasBackdrop", "class", "classList"], outputs: ["closed", "close"], exportAs: ["matMenu"] }, { kind: "component", type: i4.MatMenuItem, selector: "[mat-menu-item]", inputs: ["role", "disabled", "disableRipple"], exportAs: ["matMenuItem"] }, { kind: "directive", type: i4.MatMenuTrigger, selector: "[mat-menu-trigger-for], [matMenuTriggerFor]", inputs: ["mat-menu-trigger-for", "matMenuTriggerFor", "matMenuTriggerData", "matMenuTriggerRestoreFocus"], outputs: ["menuOpened", "onMenuOpen", "menuClosed", "onMenuClose"], exportAs: ["matMenuTrigger"] }, { kind: "component", type: i5.ConfiguracoesComponent, selector: "lib-configuracoes" }, { kind: "directive", type: i6.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i6.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i1$2.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "directive", type: i1$1.MatDialogClose, selector: "[mat-dialog-close], [matDialogClose]", inputs: ["aria-label", "type", "mat-dialog-close", "matDialogClose"], exportAs: ["matDialogClose"] }, { kind: "directive", type: i8.MatTooltip, selector: "[matTooltip]", inputs: ["matTooltipPosition", "matTooltipPositionAtOrigin", "matTooltipDisabled", "matTooltipShowDelay", "matTooltipHideDelay", "matTooltipTouchGestures", "matTooltip", "matTooltipClass"], exportAs: ["matTooltip"] }, { kind: "component", type: i9.MatButton, selector: "    button[mat-button], button[mat-raised-button], button[mat-flat-button],    button[mat-stroked-button]  ", exportAs: ["matButton"] }, { kind: "component", type: i9.MatIconButton, selector: "button[mat-icon-button]", exportAs: ["matButton"] }, { kind: "component", type: i10.LibFormularioVidaComponent, selector: "lib-formulario-vida", inputs: ["draft", "exibirTitulo", "ramo"], outputs: ["matStepRouteEvent", "salvarEvent"] }, { kind: "component", type: i11.LibFormularioAutoComponent, selector: "lib-formulario-auto", inputs: ["draft", "exibirTitulo", "novoLoader", "nomeLoader", "ramo", "inputMask"], outputs: ["changeSeguradoraSelectedEvent", "changeTpCoberturaSelectedEvent", "matStepRouteEvent", "salvarEvent", "buscaCotacoesEvent"] }, { kind: "component", type: i12.CoberturasAutoComponent, selector: "lib-coberturas-auto", inputs: ["listaCampo"], outputs: ["matStepRouteEvent"] }], animations: [
            trigger('fadeInOut', [
                transition(':enter', [
                    style({ opacity: 0 }),
                    animate(150, style({ opacity: 1 })),
                ]),
                transition(':leave', [
                    animate(150, style({ opacity: 0 }))
                ])
            ])
        ] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: RecalculoModalComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-recalculo-modal', animations: [
                        trigger('fadeInOut', [
                            transition(':enter', [
                                style({ opacity: 0 }),
                                animate(150, style({ opacity: 1 })),
                            ]),
                            transition(':leave', [
                                animate(150, style({ opacity: 0 }))
                            ])
                        ])
                    ], template: "<div class=\"modal-container recalculo\">\r\n\r\n  <header class=\"header\">\r\n      <div>\r\n          <section *ngIf=\"seguradoraId\">\r\n              <img class=\"logo-seg\" src=\"assets/images/logos-seguradoras/seguradora{{seguradoraId}}.png\" alt=\"Logo seguradora\">\r\n          </section>\r\n          <section class=\"info\">\r\n              <h1>Recalcular Cota\u00E7\u00E3o</h1>\r\n              <span> {{nomeSeguradora}}</span>\r\n          </section>\r\n      </div>\r\n      <section class=\"button-close-modal\" id=\"botao-recalculo\">\r\n        <button mat-icon-button [mat-dialog-close]=\"true\" class=\"button-close\">\r\n            <mat-icon>close</mat-icon>\r\n        </button>\r\n      </section>\r\n  </header>\r\n\r\n  <main class=\"informacao-erro\">\r\n    <div>\r\n        <mat-icon svgIcon=\"alert-circle-outline\"></mat-icon>\r\n        <span>Foram identificados os seguintes erros durante a tentativa de gerar o c\u00E1lculo:</span>\r\n    </div>\r\n    <ul>\r\n        <li *ngFor=\"let erro of msErros\">\r\n            {{erro}}\r\n        </li>\r\n    </ul>\r\n  </main>\r\n    <span class=\"sub-title\">\r\n       Fa\u00E7a as altera\u00E7\u00F5es necess\u00E1rias para recalcular nesta seguradora.\r\n    </span>\r\n\r\n    <div class=\"section-seg\" *ngIf=\"habilitaComponent?.seguradoras && dataSeguradora\">\r\n        <lib-configuracoes #modalSeguradora id=\"recalculo-seguradora-modal\"></lib-configuracoes>\r\n    </div>\r\n\r\n    <div class=\"section-seg\" *ngIf=\"this.habilitaComponent.ramo == this._ramos.VIDA\">\r\n          <lib-formulario-vida\r\n          #formulario\r\n          *ngIf=\"campos\"\r\n          id=\"form-vida-recalculo\">\r\n          </lib-formulario-vida>\r\n    </div>\r\n\r\n    <div class=\"section-seg\" *ngIf=\"this.habilitaComponent.ramo == this._ramos.AUTO\">\r\n      <lib-formulario-auto\r\n        #formulario\r\n        *ngIf=\"campos\"\r\n        id=\"form-vida-recalculo\">\r\n      </lib-formulario-auto>\r\n      <lib-coberturas-auto\r\n        #coberturasAuto\r\n        *ngIf=\"campos\"\r\n        [listaCampo]=\"campos\"\r\n        id=\"form-vida-recalculo\">\r\n      </lib-coberturas-auto>\r\n    </div>\r\n\r\n</div>\r\n\r\n<div class=\"modal-bottom footer-recalc\">\r\n  <section id=\"footer-recalculo\">\r\n    <button mat-button class=\"recalcular font-18\"\r\n            *ngIf=\"habilitaComponent?.seguradoras\"\r\n            [disabled]=\"recalcularControler.desabilita\"\r\n            [ngClass]=\"recalcularControler.desabilita ? 'desabilitado' : ''\"\r\n            [matTooltip]=\"recalcularControler.desabilita ? recalcularControler.mensagem : 'Recalcular apenas esta seguradora na mesma vers\u00E3o'\"\r\n            [matTooltipPosition]=\"'above'\"\r\n            (click)=\"calcular(1)\">Recalcular</button>\r\n\r\n            <!-- [disabled]=\"recalcularControler.desabilita\" -->\r\n     <button mat-button class=\"recalcular font-18\"\r\n            *ngIf=\"!habilitaComponent?.seguradoras\"\r\n\r\n            [ngClass]=\"recalcularControler.desabilita ? 'desabilitado' : ''\"\r\n            [matMenuTriggerFor]=\"menu\">Recalcular</button>\r\n\r\n     <mat-menu #menu=\"matMenu\" yPosition=\"above\">\r\n       <p class=\"text-recalc\">Nova vers\u00E3o</p>\r\n       <button mat-menu-item class=\"menuItem-recalculo\" (click)=\"calcular(2)\" >Todas seguradoras</button>\r\n       <button mat-menu-item class=\"menuItem-recalculo\" (click)=\"calcular(1)\" >Apenas esta seguradora</button>\r\n     </mat-menu>\r\n  </section>\r\n</div>\r\n", styles: ["@import\"https://fonts.googleapis.com/css?family=Montserrat:500,600,600i,700\";@import\"https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;1,100;1,200;1,300;1,400;1,500;1,600;1,700&display=swap\";.recalculo{font-family:IBM Plex Sans!important}.modal-container{display:flex;flex-direction:column;width:auto;padding:24px}::ng-deep #modalseguradora>button{display:flex}::ng-deep #recalculo-seguradora-modal #modalseguradora{overflow:hidden!important;padding:0}.header{display:flex;align-items:center;justify-content:space-between}.header div{display:flex;align-items:center}.header .logo-seg{width:60px}.header .info{padding-left:16px;align-items:center;padding-top:14px}.header .info h1{margin:0;font-size:18px;font-weight:500;line-height:0px;text-align:left;color:#454750}.header .info span{line-height:49px;font-size:16px;font-weight:500;text-align:left;color:#7e7f86}.header .button-close-modal{width:10px;position:relative;right:27px;top:-14px}.informacao-erro{margin:15px 0;border:1px solid #e5e6e7;border-radius:5px;padding:0}.informacao-erro div{display:flex;align-content:center;align-items:center}.informacao-erro div span{font-size:12px;font-weight:400;color:#60616a}.informacao-erro div mat-icon{margin:10px 12px;color:#d0b249;width:17px}.informacao-erro ul li{font-size:12px;font-weight:400;color:#60616a;list-style:disc!important;margin-left:40px!important;padding-bottom:15px}.sub-title{font-size:14px;font-weight:500;color:#9c9da2;margin-bottom:4px}.footer-recalc{display:flex;width:100%;justify-content:flex-end;border-top:1px #d0d0d0 solid;padding:15px 5%;height:54px}.footer-recalc section{display:flex;align-content:center;align-items:center}.modal-bottom section .recalcular{font-family:IBM Plex Sans!important;font-size:15px;letter-spacing:normal;text-transform:uppercase;float:right;text-decoration:none;font-style:normal;font-weight:500;line-height:normal;letter-spacing:.24px}.modal-bottom section .recalcular:not(.desabilitado){cursor:pointer;color:var(--primary);font-family:IBM Plex Sans!important;font-size:15px;font-style:normal;font-weight:500;line-height:normal;letter-spacing:.24px}.modal-bottom section .nova-versao{font-size:15px;font-family:IBM Plex Sans!important;letter-spacing:normal;text-transform:uppercase;float:right;text-decoration:none;margin-right:21px;display:flex;gap:4px;font-style:normal;font-weight:500;line-height:normal;letter-spacing:.24px}.modal-bottom section .nova-versao:not(.desabilitado){font-size:15px;cursor:pointer;color:#000;font-family:IBM Plex Sans!important;font-style:normal;font-weight:500;line-height:normal;letter-spacing:.24px}.modal-bottom section .desabilitado{font-size:15px;cursor:default;color:#00000061;font-family:IBM Plex Sans!important;font-style:normal;font-weight:500;line-height:normal;letter-spacing:.24px}::ng-deep #form-vida-recalculo .container-form-auto .mat-mdc-form-field{padding:0!important}::ng-deep #form-vida-recalculo .mat-expansion-panel{box-shadow:none;margin:0!important;padding:0!important}::ng-deep #form-vida-recalculo .title-hide,::ng-deep #form-vida-recalculo .desabilitado{display:none}::ng-deep #form-vida-recalculo .mat-expansion-panel-content{margin:0!important;padding:0!important}::ng-deep #form-vida-recalculo .mat-accordion{margin:0!important}::ng-deep #form-vida-recalculo .mat-expansion-panel-body{padding:0 0 7px}::ng-deep #form-vida-recalculo .container-form .mat-accordion{margin:0!important}::ng-deep #form-vida-recalculo .form-step{padding:0!important}::ng-deep #form-vida-recalculo .mat-mdc-card{border:none;box-shadow:none;background:none;padding:0;margin:0}::ng-deep #form-vida-recalculo .container-form{padding:0}::ng-deep #form-vida-recalculo .container-coberturas .card-coberturas .container-title h2{margin:-42px 0 10px!important;padding:7px!important}::ng-deep #form-vida-recalculo .container-coberturas .mat-mdc-form-field{padding:0!important}::ng-deep #recalculo-seguradora-modal #modalseguradora .fields{padding:0!important;margin:0!important}::ng-deep #recalculo-seguradora-modal #modalseguradora{display:contents}::ng-deep #recalculo-seguradora-modal #modalseguradora form{padding:0!important}::ng-deep #recalculo-seguradora-modal #modalseguradora .fields .organizarPadrao .title h3{color:#202124;font-size:15px;margin:0;font-weight:400}::ng-deep #recalculo-seguradora-modal #modalseguradora .mat-mdc-text-field-wrapper .mat-mdc-form-field-infix .mat-mdc-floating-label{letter-spacing:1.8px}::ng-deep #recalculo-seguradora-modal #modalseguradora .fields .organizarPadrao .campoSenha .mat-mdc-form-field-icon-suffix button{margin:0 0 -20px}::ng-deep #recalculo-seguradora-modal #modalseguradora .fields .organizarPadrao .campoSenha .mat-mdc-form-field-icon-suffix button mat-icon{font-size:19px}::ng-deep #recalculo-seguradora-modal #modalseguradora .fields .organizarPadrao .campo .mat-mdc-button .credencial-valida{color:#000000de;margin-top:8px;font-size:13px}::ng-deep #botao-recalculo .mat-mdc-icon-button,::ng-deep #botao-recalculo .mat-mdc-icon-button:hover,::ng-deep #botao-recalculo .mat-mdc-icon-button:active,::ng-deep #botao-recalculo .mat-mdc-icon-button:focus{--mat-mdc-button-persistent-ripple-color:none }::ng-deep .menuItem-recalculo .mdc-list-item__primary-text{color:var(--color-tertiary-first);font-family:IBM Plex Sans;font-size:16px;font-style:normal;font-weight:400;line-height:normal;letter-spacing:.24px}::ng-deep .menuItem-recalculo{color:var(--color-tertiary-first)}::ng-deep .menuItem-recalculo:hover{background:var(--color-tertiary-first)}::ng-deep .text-recalc{color:var(--gray-scale-200, #7E8088);font-family:IBM Plex Sans;font-size:12px;font-style:normal;font-weight:500;line-height:normal;margin:0 17px 4px!important;letter-spacing:.18px}\n"] }]
        }], ctorParameters: () => [{ type: i1$1.MatDialogRef }, { type: RegisterIconsService }, { type: RecalculoService }], propDecorators: { seg: [{
                type: Input
            }], libSeg: [{
                type: Input
            }], habilitar: [{
                type: Input
            }], dataForm: [{
                type: Input
            }], erros: [{
                type: Input
            }], config: [{
                type: Input
            }], injetado: [{
                type: Input
            }], seguradorasInfo: [{
                type: Input
            }], aplicacaoId: [{
                type: Input
            }], contentFormulario: [{
                type: ViewChild,
                args: ['formulario']
            }], contentCoberturas: [{
                type: ViewChild,
                args: ['coberturasAuto']
            }], contentModalSeguradora2: [{
                type: ViewChild,
                args: ['modalSeguradora']
            }] } });

// import { SeguradorasComponent, Integracao as IntegracaoSeguradoras } from '../../../seguradoras/src/public-api';
class RecalculoComponent {
    injetado;
    dialogRef;
    router;
    service;
    registerIcon;
    _snackBar;
    loader = true;
    libSeguradoras;
    wakUser = {};
    token;
    msErros = [];
    abrirSegs = false;
    seguradorasStatus = false;
    campos = [];
    versaoCertaRecalculo = null;
    tipoEdicao = {
        ramo: false,
        seguradoras: false,
    };
    modalSegConfig;
    _ramos = ConstantRecalculo.ramos;
    seguradoras = Integracao.seguradoraId;
    objetoRecalculo;
    set contentModalSeguradora(contentModalSeguradora) {
        this.libSeguradoras = contentModalSeguradora;
        this.abrirSegs = true;
    }
    constructor(injetado, dialogRef, router, service, registerIcon, _snackBar) {
        this.injetado = injetado;
        this.dialogRef = dialogRef;
        this.router = router;
        this.service = service;
        this.registerIcon = registerIcon;
        this._snackBar = _snackBar;
        const icons = ['calculator'];
        this.setConfig();
        registerIcon.registerIcons(icons);
    }
    async setConfig() {
        debugger;
        const tk = await this.injetado.api.getToken();
        let dados = this.service.calculosElegiveis(this.injetado.ramo, this.injetado.seguradora, this.injetado.codigoErroPrincipal);
        const segInfo = await this.injetado.api.getServicesInfos();
        const wakUser = await this.injetado.api.getUserInfos();
        let segStatus = this.injetado.cotacaoService.getSeguradorasStatus(wakUser.confsSeguradora, segInfo, this.injetado.ramo, this.getEstadoSegurado(this.injetado?.proposta));
        let aplicacao = this.injetado.api.getAplicacaoId();
        this.injetado =
            {
                ...this.injetado,
                ...dados,
                token: tk,
                wakUser: wakUser,
                aplicacao: aplicacao,
                segInfo: segStatus,
            };
    }
    ngOnInit() {
        this.setConfig()
            .then(() => {
            this.abrirModal();
            this.service.eventCalculo.subscribe(this.enviaParaCalculo.bind(this));
            this.service.eventCarregado.subscribe(this.finalizaLoder.bind(this));
        });
    }
    finalizaLoder(event) {
        this.loader = event;
    }
    async enviaParaCalculo(event) {
        if (this.injetado) {
            let obj = {
                seguradora: this.injetado.seguradora,
                idIntegracao: this.injetado.idCalculo,
                novaVersao: event.newVersion,
            };
            try {
                let ret = null;
                if (!event.newVersion) {
                    setTimeout(async () => {
                        ret = await this.injetado.api.reenviar(this.injetado.idCalculo);
                        this.clearInjetado();
                        this.dialogRef.close(obj);
                    }, 1500);
                    this.loader = true;
                    return;
                }
                let calculos = [];
                let sendDraft = event.sendDraft;
                if (!event.all) {
                    let seg;
                    if (this.injetado.seguradora == this.seguradoras.AZUL.value || this.injetado.seguradora == this.seguradoras.ITAU.value) {
                        seg = sendDraft.calculos.find(seg => seg.seguradora == this.seguradoras.PORTO_SEGURO.value);
                        if (seg) {
                            calculos.push(seg);
                            seg = sendDraft.calculos.find(seg => seg.seguradora == this.injetado.seguradora);
                            if (seg)
                                calculos.unshift(seg);
                        }
                        else {
                            calculos = seg ? calculos : sendDraft.calculos;
                        }
                    }
                    else {
                        seg = sendDraft.calculos.find(seg => seg.seguradora == this.injetado.seguradora);
                        calculos.push(seg);
                        console.log('seguradoras ', sendDraft.calculos);
                        console.log('seguradora desejada => ', this.injetado.seguradora);
                        if (seg)
                            calculos = calculos;
                        else {
                            this._snackBar.open('Não foi possível reenviar está seguradora.', 'Fechar', {
                                duration: 3000,
                                panelClass: 'red-snackbar'
                            });
                            return;
                        }
                    }
                }
                else {
                    calculos = sendDraft.calculos.filter(item => {
                        if (this.injetado.arrSegs.includes(item.seguradora))
                            return item;
                    });
                }
                calculos.filter((seg) => {
                    try {
                        let config = this.injetado.proposta.calculos.find(item => item.seguradora == seg.seguradora);
                        seg.percComissao = config?.percComissao;
                        seg.percComissao2 = config?.percComissao2;
                        seg.percComissao3 = config?.percComissao3;
                        seg.percComissaoCond = config?.percComissaoCond;
                        seg.percDesconto = config?.percDesconto;
                        seg.percDescontoCond = config?.percDescontoCond;
                    }
                    catch (error) { }
                    return seg;
                });
                sendDraft.calculos = calculos;
                if (!sendDraft.segurado.fone)
                    sendDraft.segurado.fone = sendDraft.segurado.fone1;
                if (sendDraft.vigFimAnterior == "") {
                    sendDraft.vigIniAnterior = null;
                    sendDraft.vigFimAnterior = null;
                }
                ret = await this.injetado.api.calcular(sendDraft);
                ret = true;
                this.clearInjetado();
                this.dialogRef.close(obj);
            }
            catch (e) {
                console.log(e);
                this.clearInjetado();
                this.dialogRef.close(obj);
            }
        }
    }
    habilitaCampos(obj) {
        this.campos = obj;
        Object.keys(this.campos).forEach(key => {
            this.campos[key] = this.injetado.attribute.includes(key);
        });
    }
    async abrirModal() {
        let form = {};
        form[this._ramos.AUTO] = Erros.formAuto;
        form[this._ramos.VIDA] = Erros.formVida;
        this.msErros = Array.isArray(this.injetado.erros) ? this.injetado.erros : [this.injetado.erros];
        debugger;
        if (this.injetado.tipoCorrecao == "SEGURADORA") {
            this.wakUser.data = this.injetado.wakUser;
            this.tipoEdicao.seguradoras = true;
        }
        else if (this.injetado.tipoCorrecao == "FORM") {
            let formSelecionado = form[this.injetado.ramo];
            this.habilitaCampos(formSelecionado);
            this.seguradorasStatus = this.injetado.segInfo;
            this.tipoEdicao.ramo = this.injetado.ramo;
        }
        else if (this.injetado.tipoCorrecao = "REENVIAR") {
            this.injetado.reenviar = true;
            let novaVersao = false;
            let seguradorasVersaoNovaObrigatoria = [10, 9];
            if (seguradorasVersaoNovaObrigatoria.includes(this.injetado.seguradora))
                novaVersao = true;
            let novaVersao2 = await this.verificaData();
            let obj = {};
            if (novaVersao || novaVersao2) {
                this.seguradorasStatus = this.injetado.segInfo;
                obj = {
                    newVersion: true,
                    sendDraft: this.injetado.proposta
                };
            }
            else {
                obj = {
                    newVersion: false,
                };
            }
            await this.enviaParaCalculo(obj);
        }
    }
    verificaData() {
        let mudou = false;
        let hoje = new Date();
        let vigIni = new Date(this.injetado.proposta.vigenciaIni);
        let limiteRetroativo = new Date();
        limiteRetroativo = this.editarData({ data: limiteRetroativo, operacao: "-", dia: 15, mes: 0, ano: 0 });
        if (limiteRetroativo) {
            if (limiteRetroativo.getTime() > vigIni.getTime()) {
                mudou = true;
                this.injetado.proposta.vigenciaIni = hoje.toISOString();
                hoje.setFullYear(hoje.getFullYear() + 1);
                this.injetado.proposta.vigenciaFim = hoje.toISOString();
            }
        }
        return mudou;
    }
    editarData(objDate) {
        try {
            let dt = new Date(objDate.data);
            if (objDate.operacao == '+') {
                dt.setFullYear(dt.getFullYear() + objDate.ano);
                dt.setDate(dt.getDate() + objDate.dia);
                dt.setMonth(dt.getMonth() + objDate.mes);
                objDate.hora && dt.setHours(dt.getHours() + objDate.hora);
            }
            else if (objDate.operacao == '-') {
                dt.setFullYear(dt.getFullYear() - objDate.ano);
                dt.setDate(dt.getDate() - objDate.dia);
                dt.setMonth(dt.getMonth() - objDate.mes);
                objDate.hora && dt.setHours(dt.getHours() - objDate.hora);
            }
            return dt;
        }
        catch (error) {
            return false;
        }
    }
    clearInjetado() {
        delete this.injetado;
    }
    getEstadoSegurado(proposta) {
        try {
            if (proposta && proposta?.segurado) {
                if (proposta.segurado?.uf)
                    return proposta.segurado.uf;
                else if (proposta.segurado?.residUF)
                    return proposta.segurado.residUF;
            }
            else {
                return false;
            }
        }
        catch (error) {
            return false;
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: RecalculoComponent, deps: [{ token: MAT_DIALOG_DATA }, { token: i1$1.MatDialogRef }, { token: i2$1.Router }, { token: RecalculoService }, { token: RegisterIconsService }, { token: i5$1.MatSnackBar }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: RecalculoComponent, selector: "lib-recalculo", viewQueries: [{ propertyName: "contentModalSeguradora", first: true, predicate: ["libSeguradoras"], descendants: true }], ngImport: i0, template: "\r\n<div class=\"content-loader\" [hidden]=\"!loader\">\r\n  <div *ngIf=\"this.injetado?.aplicacao == 3\">\r\n    <img class=\"apice\" src=\"assets/images/loader-apice.gif\">\r\n    <h2 *ngIf=\"this.injetado?.reenviar\">Aguarde! Estamos enviado esse c\u00E1lculo</h2>\r\n  </div>\r\n\r\n  <div *ngIf=\"this.injetado?.aplicacao == 1\">\r\n    <img class=\"multi\" src=\"assets/images/loader-multi.gif\">\r\n    <h2 *ngIf=\"this.injetado?.reenviar\">Aguarde! Estamos enviado esse c\u00E1lculo</h2>\r\n</div>\r\n\r\n</div>\r\n\r\n<div [hidden]=\"loader\">\r\n  <app-recalculo-modal\r\n    [habilitar]=\"tipoEdicao\"\r\n    [seg]=\"this.injetado?.seguradora\"\r\n    [config]=\"campos\"\r\n    [erros]=\"msErros\"\r\n    [injetado]=\"this.injetado\"\r\n    [seguradorasInfo]=\"seguradorasStatus\"\r\n    [aplicacaoId]=\"this.injetado?.aplicacao\"\r\n    [dataForm]=\"abrirSegs\"\r\n    *ngIf=\"tipoEdicao?.seguradoras || tipoEdicao?.ramo\">\r\n  </app-recalculo-modal>\r\n</div>\r\n\r\n<lib-seguradoras\r\n  *ngIf=\"tipoEdicao?.seguradoras\"\r\n  #libSeguradoras\r\n  hidden\r\n></lib-seguradoras>\r\n\r\n\r\n", styles: [".content-loader{height:500px;display:table;width:100%}.content-loader div{display:table-cell;vertical-align:middle;width:100%}.content-loader div .multi{display:block;margin:0 auto;width:180px;height:62px}.content-loader div .apice{display:block;margin:0 auto;width:164px;height:140px}.content-loader div h2{text-align:center;padding:30px}::ng-deep .red-snackbar button .mdc-button__label{color:#ea5869;border:none;font-weight:500}\n"], dependencies: [{ kind: "directive", type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: RecalculoModalComponent, selector: "app-recalculo-modal", inputs: ["seg", "libSeg", "habilitar", "dataForm", "erros", "config", "injetado", "seguradorasInfo", "aplicacaoId"] }, { kind: "component", type: i5.SeguradorasComponent, selector: "lib-seguradoras", outputs: ["segSaveEvent"] }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: RecalculoComponent, decorators: [{
            type: Component,
            args: [{ selector: 'lib-recalculo', template: "\r\n<div class=\"content-loader\" [hidden]=\"!loader\">\r\n  <div *ngIf=\"this.injetado?.aplicacao == 3\">\r\n    <img class=\"apice\" src=\"assets/images/loader-apice.gif\">\r\n    <h2 *ngIf=\"this.injetado?.reenviar\">Aguarde! Estamos enviado esse c\u00E1lculo</h2>\r\n  </div>\r\n\r\n  <div *ngIf=\"this.injetado?.aplicacao == 1\">\r\n    <img class=\"multi\" src=\"assets/images/loader-multi.gif\">\r\n    <h2 *ngIf=\"this.injetado?.reenviar\">Aguarde! Estamos enviado esse c\u00E1lculo</h2>\r\n</div>\r\n\r\n</div>\r\n\r\n<div [hidden]=\"loader\">\r\n  <app-recalculo-modal\r\n    [habilitar]=\"tipoEdicao\"\r\n    [seg]=\"this.injetado?.seguradora\"\r\n    [config]=\"campos\"\r\n    [erros]=\"msErros\"\r\n    [injetado]=\"this.injetado\"\r\n    [seguradorasInfo]=\"seguradorasStatus\"\r\n    [aplicacaoId]=\"this.injetado?.aplicacao\"\r\n    [dataForm]=\"abrirSegs\"\r\n    *ngIf=\"tipoEdicao?.seguradoras || tipoEdicao?.ramo\">\r\n  </app-recalculo-modal>\r\n</div>\r\n\r\n<lib-seguradoras\r\n  *ngIf=\"tipoEdicao?.seguradoras\"\r\n  #libSeguradoras\r\n  hidden\r\n></lib-seguradoras>\r\n\r\n\r\n", styles: [".content-loader{height:500px;display:table;width:100%}.content-loader div{display:table-cell;vertical-align:middle;width:100%}.content-loader div .multi{display:block;margin:0 auto;width:180px;height:62px}.content-loader div .apice{display:block;margin:0 auto;width:164px;height:140px}.content-loader div h2{text-align:center;padding:30px}::ng-deep .red-snackbar button .mdc-button__label{color:#ea5869;border:none;font-weight:500}\n"] }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [MAT_DIALOG_DATA]
                }] }, { type: i1$1.MatDialogRef }, { type: i2$1.Router }, { type: RecalculoService }, { type: RegisterIconsService }, { type: i5$1.MatSnackBar }], propDecorators: { contentModalSeguradora: [{
                type: ViewChild,
                args: ['libSeguradoras']
            }] } });

// import { LibFormularioVidaModule } from 'projects/formulario-vida/src/public-api';
// import { SeguradorasModule, ConfiguracoesModule} from 'projects/seguradoras/src/public-api';
// import { LibFormularioAutoModule } from 'projects/formulario-auto/src/public-api';
// import { LibCoberturasAutoModule } from 'projects/coberturas-auto/src/public-api';
class RecalculoModalModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: RecalculoModalModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: RecalculoModalModule, declarations: [RecalculoModalComponent], imports: [SeguradorasModule,
            MatMenuModule,
            ConfiguracoesModule,
            CommonModule,
            MatTableModule,
            MatIconModule,
            MatDialogModule,
            MatFormFieldModule,
            MatInputModule,
            MatSelectModule,
            FormsModule,
            MatTooltipModule,
            MatListModule,
            MatButtonModule,
            MatSortModule,
            MatExpansionModule,
            MatProgressSpinnerModule,
            ReactiveFormsModule,
            NgxMaskDirective,
            NgxMaskPipe,
            MatAutocompleteModule,
            MatSlideToggleModule,
            // libs
            LibFormularioVidaModule,
            LibFormularioAutoModule,
            LibCoberturasAutoModule], exports: [RecalculoModalComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: RecalculoModalModule, providers: [
            provideNgxMask(),
        ], imports: [SeguradorasModule,
            MatMenuModule,
            ConfiguracoesModule,
            CommonModule,
            MatTableModule,
            MatIconModule,
            MatDialogModule,
            MatFormFieldModule,
            MatInputModule,
            MatSelectModule,
            FormsModule,
            MatTooltipModule,
            MatListModule,
            MatButtonModule,
            MatSortModule,
            MatExpansionModule,
            MatProgressSpinnerModule,
            ReactiveFormsModule,
            MatAutocompleteModule,
            MatSlideToggleModule,
            // libs
            LibFormularioVidaModule,
            LibFormularioAutoModule,
            LibCoberturasAutoModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: RecalculoModalModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [RecalculoModalComponent,],
                    imports: [
                        SeguradorasModule,
                        MatMenuModule,
                        ConfiguracoesModule,
                        CommonModule,
                        MatTableModule,
                        MatIconModule,
                        MatDialogModule,
                        MatFormFieldModule,
                        MatInputModule,
                        MatSelectModule,
                        FormsModule,
                        MatTooltipModule,
                        MatListModule,
                        MatButtonModule,
                        MatSortModule,
                        MatExpansionModule,
                        MatProgressSpinnerModule,
                        ReactiveFormsModule,
                        NgxMaskDirective,
                        NgxMaskPipe,
                        MatAutocompleteModule,
                        MatSlideToggleModule,
                        // libs
                        LibFormularioVidaModule,
                        LibFormularioAutoModule,
                        LibCoberturasAutoModule,
                    ],
                    exports: [RecalculoModalComponent],
                    providers: [
                        provideNgxMask(),
                    ]
                }]
        }] });

// import { SeguradorasModule } from 'projects/seguradoras/src/public-api';
class RecalculoModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: RecalculoModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: RecalculoModule, declarations: [RecalculoComponent], imports: [CommonModule,
            MatIconModule,
            MatDialogModule,
            MatFormFieldModule,
            MatSelectModule,
            MatButtonModule,
            MatTooltipModule,
            RecalculoModalModule,
            SeguradorasModule,
            MatSnackBarModule], exports: [RecalculoComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: RecalculoModule, providers: [
            RecalculoService,
            ConstantRecalculo
        ], imports: [CommonModule,
            MatIconModule,
            MatDialogModule,
            MatFormFieldModule,
            MatSelectModule,
            MatButtonModule,
            MatTooltipModule,
            RecalculoModalModule,
            SeguradorasModule,
            MatSnackBarModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: RecalculoModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        RecalculoComponent
                    ],
                    imports: [
                        CommonModule,
                        MatIconModule,
                        MatDialogModule,
                        MatFormFieldModule,
                        MatSelectModule,
                        MatButtonModule,
                        MatTooltipModule,
                        RecalculoModalModule,
                        SeguradorasModule,
                        MatSnackBarModule,
                    ],
                    exports: [
                        RecalculoComponent
                    ],
                    providers: [
                        RecalculoService,
                        ConstantRecalculo
                    ]
                }]
        }] });

/*
 * Public API Surface of recalculo
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ConstantRecalculo, RecalculoComponent, RecalculoModule, RecalculoService };
